module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/components/multiple-offers/multiple-offers.component.scss
// module id = ./src/app/authentication/components/multiple-offers/multiple-offers.component.scss
// module chunks = main